module.exports = __webpack_public_path__ + "6e3a01fe54c151c79713ea054c5f6e56.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/blow-dryer-s.png
// module id = 2604
// module chunks = 0